var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    tabIndex: 0,
    "aria-label": "Share icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 11.1A4 4 0 0 0 24 7a4 4 0 0 0-4.12-4.12A4 4 0 0 0 15.7 7v.32L11 8.49A5.45 5.45 0 0 0 5.72 5a5.48 5.48 0 0 0-5.67 5.67 5.48 5.48 0 0 0 5.67 5.66 5.67 5.67 0 0 0 3.85-1.43l4.64 3.24a4.1 4.1 0 0 0-.16 1.06 3.55 3.55 0 0 0 3.67 3.67 3.54 3.54 0 0 0 3.66-3.67 3.54 3.54 0 0 0-3.66-3.66 3.57 3.57 0 0 0-2.92 1.39l-4.34-3a5.83 5.83 0 0 0 .92-3.23 6 6 0 0 0-.08-.88L16 8.6a4 4 0 0 0 3.83 2.5m0-6.92A2.67 2.67 0 0 1 22.62 7a2.67 2.67 0 0 1-2.79 2.8A2.68 2.68 0 0 1 17 7a2.67 2.67 0 0 1 2.83-2.82m-2.11 12.69a2.23 2.23 0 0 1 2.33 2.33 2.23 2.23 0 0 1-2.33 2.34 2.24 2.24 0 0 1-2.34-2.34 2.23 2.23 0 0 1 2.34-2.33M5.72 15a4.15 4.15 0 0 1-4.34-4.33 4.15 4.15 0 0 1 4.34-4.34 4.14 4.14 0 0 1 4.33 4.34A4.14 4.14 0 0 1 5.72 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.570eac6b433ed8760442900ef96923f9.svg";
export { ForwardRef as ReactComponent };